"use client";

import { useState } from 'react';

export default function TelecomDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'CEO / CFO TELECOM DASHBOARD',
      subtitle: 'Executive Subscriber & Revenue Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Telecom Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'ARPU', value: '₹485', color: '#C5A572' },
            { x: 186, label: 'Churn Rate', value: '2.8%', color: '#dc2626' },
            { x: 356, label: 'Total Subscribers', value: '5.2M', color: '#16a34a' },
            { x: 526, label: 'Network ROI', value: '142%', color: '#16a34a' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Subscriber Growth Trend */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Subscriber Growth Trend (M)</text>
          <polyline points="40,285 80,278 120,270 160,262 200,255 240,248 280,240 320,232" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" />
          <polyline points="40,285 80,278 120,270 160,262 200,255 240,248 280,240 320,232 320,295 40,295 Z" fill="#1B2845" opacity="0.05" />
          {[40,80,120,160,200,240,280,320].map((x, i) => (
            <circle key={i} cx={x} cy={[285,278,270,262,255,248,240,232][i]} r="3" fill="#C5A572" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug'].map((m, i) => (
            <text key={i} x={40 + i * 40 - 6} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}

          {/* Revenue by Service Type */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Revenue by Service Type (₹ Cr)</text>
          {[
            { service: 'Data Services', val: 185, color: '#1B2845' },
            { service: 'Voice Services', val: 92, color: '#C5A572' },
            { service: 'Enterprise', val: 68, color: '#3b82f6' },
            { service: 'Value-Added', val: 34, color: '#8b5cf6' },
          ].map((r, i) => (
            <g key={i}>
              <text x="370" y={172 + i * 30} fill="#374151" fontSize="9" fontFamily="sans-serif">{r.service}</text>
              <rect x="460" y={160 + i * 30} width={r.val * 1.2} height="16" fill={r.color} rx="2" opacity="0.8" />
              <text x={466 + r.val * 1.2} y={172 + i * 30} fill="#374151" fontSize="9" fontFamily="sans-serif">₹{r.val}Cr</text>
            </g>
          ))}

          {/* Churn Rate by Region */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Churn Rate by Region</text>
          {[
            { region: 'North', rate: '2.1%', color: '#16a34a' },
            { region: 'South', rate: '3.4%', color: '#ca8a04' },
            { region: 'East', rate: '4.2%', color: '#ea580c' },
            { region: 'West', rate: '1.8%', color: '#16a34a' },
          ].map((r, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{r.region}</text>
              <rect x={28 + i * 168} y="364" width="140" height="12" fill="#f3f4f6" rx="3" />
              <rect x={28 + i * 168} y="364" width={parseFloat(r.rate) * 25} height="12" fill={r.color} rx="3" opacity="0.8" />
              <text x={28 + i * 168} y="392" fill={r.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{r.rate} churn</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'NETWORK OPERATIONS DASHBOARD',
      subtitle: 'Tower Performance & Network Reliability Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Network Operations Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Network Uptime', value: '99.7%', color: '#16a34a' },
            { x: 186, label: 'Bandwidth Util.', value: '73%', color: '#C5A572' },
            { x: 356, label: 'Active Outages', value: '1', color: '#dc2626' },
            { x: 526, label: 'Congestion Alerts', value: '4', color: '#ca8a04' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Tower Performance Grid */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Tower Performance Status</text>
          {[
            ['T-001','98%','#16a34a'],['T-002','94%','#16a34a'],['T-003','87%','#65a30d'],
            ['T-004','72%','#ca8a04'],['T-005','65%','#ea580c'],['T-006','OFFLINE','#dc2626'],
            ['T-007','91%','#16a34a'],['T-008','88%','#65a30d'],['T-009','96%','#16a34a'],
          ].map(([tower, perf, color], i) => (
            <g key={i}>
              <rect x={28 + (i % 3) * 100} y={160 + Math.floor(i / 3) * 44} width="90" height="36" fill="#f9fafb" rx="5" stroke="#e5e7eb" strokeWidth="1" />
              <text x={28 + (i % 3) * 100 + 8} y={174 + Math.floor(i / 3) * 44} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{tower}</text>
              <text x={28 + (i % 3) * 100 + 8} y={186 + Math.floor(i / 3) * 44} fill={color as string} fontSize="8" fontFamily="sans-serif">{perf}</text>
              <circle cx={28 + (i % 3) * 100 + 78} cy={168 + Math.floor(i / 3) * 44} r="5" fill={color as string} opacity="0.8" />
            </g>
          ))}

          {/* Network Congestion Alerts */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Network Congestion Alerts</text>
          {[
            { area: 'Zone 4-B (Mumbai)', util: 94, color: '#dc2626', bg: '#fef2f2' },
            { area: 'Zone 2-A (Delhi)', util: 88, color: '#ea580c', bg: '#fff7ed' },
            { area: 'Zone 7-C (Bangalore)', util: 82, color: '#ca8a04', bg: '#fefce8' },
            { area: 'Zone 1-D (Chennai)', util: 71, color: '#65a30d', bg: '#f0fdf4' },
          ].map((alert, i) => (
            <g key={i}>
              <rect x="370" y={158 + i * 36} width="302" height="28" fill={alert.bg} rx="5" />
              <text x="382" y={170 + i * 36} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{alert.area}</text>
              <text x="382" y={182 + i * 36} fill={alert.color} fontSize="8" fontFamily="sans-serif">Utilization: {alert.util}%</text>
              <rect x="560" y={162 + i * 36} width="100" height="10" fill="#f3f4f6" rx="3" />
              <rect x="560" y={162 + i * 36} width={alert.util} height="10" fill={alert.color} rx="3" opacity="0.7" />
            </g>
          ))}

          {/* Service Outage Tracker */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Service Outage Tracker</text>
          {[
            { region: 'Zone 3-A', type: '4G Data', duration: '42 min', status: 'ACTIVE', color: '#dc2626' },
            { region: 'Zone 6-B', type: 'Voice', duration: '18 min', status: 'RESOLVING', color: '#ca8a04' },
            { region: 'Zone 9-C', type: '5G Data', duration: '8 min', status: 'RESOLVED', color: '#16a34a' },
          ].map((o, i) => (
            <g key={i}>
              <text x={28 + i * 224} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{o.region} — {o.type}</text>
              <text x={28 + i * 224} y="372" fill="#6b7280" fontSize="8" fontFamily="sans-serif">Duration: {o.duration}</text>
              <rect x={28 + i * 224} y="378" width="65" height="16" fill={o.color} rx="3" opacity="0.12" />
              <text x={28 + i * 224 + 4} y="390" fill={o.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{o.status}</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'CUSTOMER ANALYTICS DASHBOARD',
      subtitle: 'Subscriber Behavior & Churn Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Customer Analytics Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'NPS Score', value: '68', color: '#16a34a' },
            { x: 186, label: 'High Churn Risk', value: '12,840', color: '#dc2626' },
            { x: 356, label: 'Avg CLV', value: '₹18,400', color: '#C5A572' },
            { x: 526, label: 'Campaign ROAS', value: '3.8×', color: '#16a34a' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Churn Prediction Score Distribution */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Churn Risk Distribution</text>
          {[
            { label: 'High Risk (>70%)', count: 12840, color: '#dc2626', pct: 12 },
            { label: 'Medium Risk (40-70%)', count: 48200, color: '#ca8a04', pct: 46 },
            { label: 'Low Risk (<40%)', count: 44960, color: '#16a34a', pct: 42 },
          ].map((seg, i) => (
            <g key={i}>
              <text x="28" y={172 + i * 42} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{seg.label}</text>
              <rect x="28" y={178 + i * 42} width="270" height="16" fill="#f3f4f6" rx="4" />
              <rect x="28" y={178 + i * 42} width={seg.pct * 2.7} height="16" fill={seg.color} rx="4" opacity="0.75" />
              <text x="305" y={190 + i * 42} fill={seg.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{seg.pct}%</text>
            </g>
          ))}

          {/* Customer Segmentation Donut */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Subscriber Segmentation</text>
          <circle cx="480" cy="220" r="52" fill="none" stroke="#f3f4f6" strokeWidth="22" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#1B2845" strokeWidth="22" strokeDasharray="196 327" strokeDashoffset="0" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#C5A572" strokeWidth="22" strokeDasharray="98 327" strokeDashoffset="-196" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#3b82f6" strokeWidth="22" strokeDasharray="33 327" strokeDashoffset="-294" />
          <text x="480" y="216" textAnchor="middle" fill="#1B2845" fontSize="14" fontWeight="bold" fontFamily="sans-serif">5.2M</text>
          <text x="480" y="230" textAnchor="middle" fill="#6b7280" fontSize="8" fontFamily="sans-serif">Subscribers</text>
          <rect x="370" y="285" width="10" height="10" fill="#1B2845" rx="2" />
          <text x="384" y="294" fill="#374151" fontSize="8" fontFamily="sans-serif">Prepaid (60%)</text>
          <rect x="450" y="285" width="10" height="10" fill="#C5A572" rx="2" />
          <text x="464" y="294" fill="#374151" fontSize="8" fontFamily="sans-serif">Postpaid (30%)</text>
          <rect x="540" y="285" width="10" height="10" fill="#3b82f6" rx="2" />
          <text x="554" y="294" fill="#374151" fontSize="8" fontFamily="sans-serif">Enterprise (10%)</text>

          {/* Campaign Performance */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Campaign Performance</text>
          {[
            { campaign: 'Retention Offer Q1', reach: '48,200', conv: '12.4%', roas: '4.2×', color: '#16a34a' },
            { campaign: '5G Upgrade Push', reach: '32,800', conv: '8.6%', roas: '3.8×', color: '#65a30d' },
            { campaign: 'Win-Back Campaign', reach: '18,400', conv: '5.2%', roas: '2.9×', color: '#ca8a04' },
          ].map((c, i) => (
            <g key={i}>
              <text x={28 + i * 224} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{c.campaign}</text>
              <text x={28 + i * 224} y="370" fill="#6b7280" fontSize="8" fontFamily="sans-serif">Reach: {c.reach} | Conv: {c.conv}</text>
              <text x={28 + i * 224} y="382" fill={c.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">ROAS: {c.roas}</text>
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Telecom Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">Purpose-built dashboards for every level of your telecom organization.</p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/50'
              }`}
            >
              {d.title.split(' ').slice(0, 3).join(' ')}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-6">
            <h3 className="font-serif text-navy text-2xl font-bold mb-1">{dashboards[activeTab].title}</h3>
            <p className="text-charcoal/60 text-sm">{dashboards[activeTab].subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards[activeTab].svg}
          </div>
          <div className="flex gap-4 mt-6">
            <button className="px-6 py-2.5 bg-navy text-white text-sm font-semibold rounded-lg hover:bg-navy/90 transition-colors">View Demo</button>
            <button className="px-6 py-2.5 border border-gold text-gold text-sm font-semibold rounded-lg hover:bg-gold/5 transition-colors">Request Customization</button>
          </div>
        </div>
      </div>
    </section>
  );
}
